import { Song } from '../types';

export function SongCard(song: Song): string {
  const tagsHtml = song.tags.map(tag => /*html*/`
    <span style="font-size: 0.72rem; padding: 0.2rem 0.5rem; border-radius: 4px; background: rgba(168, 85, 247, 0.12); color: #c084fc; border: 1px solid rgba(168, 85, 247, 0.25);">
      ${tag}
    </span>
  `).join('');

  return /*html*/`
    <div class="glass-panel" style="display: flex; flex-direction: column; overflow: hidden; height: 100%; border-top: 3px solid #a855f7;">
      
      <!-- Album Art & Play Overlay -->
      <div style="position: relative; height: 210px; overflow: hidden; background: #000;">
        <img 
          src="${song.coverImage}" 
          alt="${song.title}" 
          style="width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease;"
          onmouseover="this.style.transform='scale(1.06)'"
          onmouseout="this.style.transform='scale(1.0)'"
          onerror="this.src='/images/brand/atomix-music-banner.jpg'"
        />
        <div style="position: absolute; inset: 0; background: linear-gradient(180deg, transparent 50%, rgba(7, 8, 13, 0.9) 100%);"></div>

        <!-- Floating Badge -->
        <div style="position: absolute; top: 0.85rem; right: 0.85rem;">
          <span class="badge badge-purple">AI Audio Track</span>
        </div>

        ${song.youtubeUrl ? /*html*/`
          <a 
            href="${song.youtubeUrl}" 
            target="_blank" 
            rel="noopener noreferrer" 
            style="position: absolute; bottom: 0.85rem; right: 0.85rem; width: 44px; height: 44px; border-radius: 50%; background: #a855f7; display: flex; align-items: center; justify-content: center; color: white; box-shadow: 0 4px 15px rgba(168, 85, 247, 0.6); transition: transform 0.2s ease;"
            onmouseover="this.style.transform='scale(1.15)'"
            onmouseout="this.style.transform='scale(1.0)'"
            title="Listen on YouTube"
          >
            <sl-icon name="play-fill" style="font-size: 1.3rem; margin-left: 2px;"></sl-icon>
          </a>
        ` : ''}
      </div>

      <!-- Card Details -->
      <div style="padding: 1.4rem; display: flex; flex-direction: column; flex-grow: 1; justify-content: space-between;">
        <div>
          <h3 style="font-size: 1.15rem; font-weight: 700; color: #fff; margin-bottom: 0.4rem; line-height: 1.3;">
            ${song.title}
          </h3>
          ${song.style ? /*html*/`
            <div style="font-size: 0.8rem; color: #c084fc; margin-bottom: 0.6rem; font-weight: 500;">
              ${song.style}
            </div>
          ` : ''}
          <p style="font-size: 0.88rem; color: #94a3b8; line-height: 1.5; margin-bottom: 1.1rem;">
            ${song.description}
          </p>

          <!-- Tags -->
          <div style="display: flex; flex-wrap: wrap; gap: 0.35rem; margin-bottom: 1.25rem;">
            ${tagsHtml}
          </div>
        </div>

        <!-- Links -->
        <div style="display: flex; gap: 0.5rem; flex-wrap: wrap; border-top: 1px solid rgba(255,255,255,0.06); padding-top: 1rem;">
          ${song.youtubeUrl ? /*html*/`
            <a href="${song.youtubeUrl}" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%); padding: 0.45rem 0.85rem; font-size: 0.82rem; flex-grow: 1;">
              <sl-icon name="youtube"></sl-icon>
              <span>YouTube Video</span>
            </a>
          ` : ''}

          ${song.spotifyUrl ? /*html*/`
            <a href="${song.spotifyUrl}" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="padding: 0.45rem 0.85rem; font-size: 0.82rem;">
              <sl-icon name="spotify"></sl-icon>
              <span>Spotify</span>
            </a>
          ` : ''}
        </div>

      </div>

    </div>
  `;
}
